import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import {
  FaGraduationCap,
  FaIdBadge,
  FaTools,
  FaUserCircle,
  FaUsers,
} from "react-icons/fa";
import { User } from "../../types/Types";
import {
  getMembershipLabel,
  getConnectionMembershipDisplay,
} from "../../utils/connectionUserUtils";

interface ProfileModalYouthDetailsProps {
  selectedUser: User;
  isConnected?: boolean;
}

function ProfileModalYouthDetails({
  selectedUser,
  isConnected,
}: ProfileModalYouthDetailsProps) {
  const { t } = useTranslation();

  if (isConnected) {
    return (
      <div className="px-3">
        <hr />
        <Row>
          <Col md={4} className="mb-3 d-block d-md-none">
            <div className="d-flex align-items-start">
              <FaGraduationCap
                size={20}
                className="me-2 mt-1 text-secondary"
              />
              <div>
                <strong>{t("profile.label.educationLevel")}</strong>
                <div className="text-muted small">
                  {selectedUser.educationLevel ||
                    t("profile.notProvidedYet")}
                </div>
              </div>
            </div>
          </Col>
          <Col md={4} className="mb-3">
            <div className="d-flex align-items-start">
              <FaIdBadge
                size={20}
                className="me-2 mt-1 text-secondary"
              />
              <div>
                <strong>{t("profile.label.membershipTypeLower")}</strong>
                <div className="text-muted small">
                  {getConnectionMembershipDisplay(selectedUser) ||
                    getMembershipLabel(selectedUser.membershipName ?? "") ||
                    t("profile.notProvidedYet")}
                </div>
              </div>
            </div>
          </Col>
          <Col md={4} className="mb-3">
            <div className="d-flex align-items-start">
              <FaTools
                size={20}
                className="me-2 mt-1 text-secondary"
              />
              <div>
                <strong>{t("profile.label.skillsExperience")}</strong>
                <div className="text-muted small">
                  {selectedUser.skillsExperience ||
                    t("profile.notProvidedYet")}
                </div>
              </div>
            </div>
          </Col>
          <Col md={4} className="mb-3">
            <div className="d-flex align-items-start">
              <FaUsers
                size={20}
                className="me-2 mt-1 text-secondary"
              />
              <div>
                <strong>{t("profile.label.peerNetworking")}</strong>
                <div className="text-muted small">
                  {selectedUser.peerNetworking ||
                    t("profile.notProvidedYet")}
                </div>
              </div>
            </div>
          </Col>
          <Col className="mb-3">
            <div className="d-flex align-items-start">
              <FaUserCircle
                size={20}
                className="me-2 mt-1 text-secondary"
              />
              <div>
                <strong>{t("profile.label.about")}</strong>
                <div className="text-muted small">
                  {selectedUser.aboutYou || t("profile.notProvidedYet")}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div className="p-3 d-block d-md-none">
      <hr />
      <h5 className="fw-semibold mb-3">{t("profile.section.educationDetails")}</h5>
      <Row>
        <Col md={4} className="mb-3">
          <div className="d-flex align-items-start">
            <FaGraduationCap
              size={20}
              className="me-2 mt-1 text-secondary"
            />
            <div>
              <strong>{t("profile.label.educationLevel")}</strong>
              <div className="text-muted small">
                {selectedUser.universityCollege ||
                  t("profile.notProvidedYet")}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default memo(ProfileModalYouthDetails);
